import { create } from 'zustand';

import { IContextState, IInitialState } from './interfaces';

const initialState: IInitialState = {
  open: false,
  isObjectShareActive: false,
};

export const useTrainerTools = create<IContextState>((set) => ({
  ...initialState,
  setOpen: (open) => set({ open }),
  toggleOpen: () => set((state) => ({ open: !state.open })),
  setIsObjectShareActive: (open) => set({ open }),
}));
